export default __webpack_public_path__ + "static/media/imgActivity8-5.1b20d050.png";